export default "__VITE_ASSET__D5Uj9p2L__"